import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Ordenes from './pages/Ordenes';
import Layout from './components/Layout';
import Consulta from './pages/Consulta';
import Productos from './pages/Productos';

function ProtectedRoute({ children }) {
  const { usuario } = useAuth();
  return usuario ? children : <Navigate to="/" />;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/dashboard" element={
        <ProtectedRoute>
          <Layout><Dashboard /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/ordenes" element={
        <ProtectedRoute>
          <Layout><Ordenes /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/consulta" element={
        <ProtectedRoute>
          <Layout><Consulta /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/productos" element={
        <ProtectedRoute>
          <Layout><Productos /></Layout>
        </ProtectedRoute>
      } />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}